import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["idInput"]

  connect() {
    const datatable = document.querySelector("#datatable")
    if (!datatable || !datatable["checkbox-select-all"]) {
      return
    }

    const checkboxSelectAll = datatable["checkbox-select-all"]
    const checkedValues = checkboxSelectAll.checked.map((el) => el.value)
    this.idInputTarget.value = JSON.stringify(checkedValues)
  }
}
